import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { Filter } from "../Filter";
import { Publish } from "../Publish";
import { IAllRequirements } from "../../../models/AllRequirements";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { IReqFilter, EmptyFilter } from "../Filter";
import { Tag } from "primereact/tag";
import { SubmissionsTable } from "./SubmissionsTable";
import { POReport } from "./POReport";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVSunEditor } from "../../../shared/JVSuneditor";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { User } from "../../jvConnect/User";
import { Client_Type, Job_Type, Req_Term } from "../../../models/RequirementMast";

interface Iprops {
  open?: boolean;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
  permissions: IPermissionProps;
}

export interface IModel2 {
  open: boolean;
  singleData: IAllRequirements;
}

export const TableAll = (props: Iprops) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>; loading: boolean });
  const [tableData1, setTableData1] = useState({ tableData1: [], loading: false } as { tableData1: Array<IAllRequirements>; loading: boolean });
  const [loading, setLoading] = useState(false);
  const [reqFilter, setReqFilter] = useState<IReqFilter>(EmptyFilter);
  const [duplicatereqFilter, setduplicatereqFilter] = useState<IReqFilter>(EmptyFilter);
  const [historyTable, setHistoryTable] = useState({ req_ID: 0, open: false } as { req_ID: number; open: boolean });
  const [historytableData, setHistorytableData] = useState({ historytableData: [], loading: false } as { historytableData: Array<any>; loading: boolean });
  const [removeAllocation, setRemoveAllocation] = useState({ req_ID: 0, open: false, noSub_Allocated: null } as unknown as { req_ID: number; open: boolean; noSub_Allocated: boolean });
  const hideQueryDialog = () => {
    setRemoveAllocation({ req_ID: 0, open: false, noSub_Allocated: false });
  };
  const dt = useRef<any>(null);

  const _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
  const hidePublishDialog = () => {
    setPublish({ singleData: {}, open: false });
  };
  const [poDetails, setPODetails] = useState({ vendor_Company_ID: 0, open: false } as { vendor_Company_ID: number; open: boolean });
  const hidePODetailsDialog = () => {
    setPODetails({ vendor_Company_ID: 0, open: false });
  };
  // const [filter, setFilter] = useState(false);
  // const hideFilterDialog = () => {
  //     setFilter(false);
  // };
  const [rrr, setRRR] = useState({ open: false, rrreason: "", req_ID: 0 } as { open: boolean; rrreason: string | undefined; req_ID: number | undefined });
  const hideRRRDialog = () => {
    setRRR({ open: false, rrreason: "", req_ID: 0 });
  };
  const [openDuplicateTable, setOpenDuplicateTable] = useState({ open: false, req_ID: 0, loading: false } as { open: boolean; req_ID?: number; loading: boolean });

  const [isDuplicateReqCount, setDuplicateReqCount] = useState(0);

  const [openBlacklistSubmission, setOpenBlacklistSubmission] = useState(false);
  //   const [blacklistDetailSub, setBlacklistDetailSub] = useState<string[]>([]);
  const [blacklisttableData, setBlacklisttableData] = useState({ blacklisttableData: [], loading: false } as { blacklisttableData: Array<any>; loading: boolean });
  const [blacklistModal, setBlacklistModal] = useState({ open: false, reason: "" } as { open: boolean; reason?: string });
  useEffect(() => {
    loadTableData();
  }, [reqFilter, props.reload]);

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("Requirement_MAST", "GET", null, `filter=` + encodeURIComponent(JSON.stringify(reqFilter)) + `&tb=${1}`, props.toast);
    if (response) {
      const data: Array<IAllRequirements> = await response.json();
      setTableData({ tableData: data, loading: false });
    } else setTableData({ tableData: tableData.tableData, loading: false });
  };

  const loadTableData1 = async (req_ID?: number) => {
    setTableData1({ tableData1: tableData1.tableData1, loading: true });
    if (req_ID) {
      const response = await Fetch("Requirement_MAST/duplicateReq", "GET", null, `req_id=${req_ID}`, props.toast);
      if (response) {
        const data: Array<IAllRequirements> = await response.json();
        setTableData1({ tableData1: data, loading: false });
      } else setTableData1({ tableData1: tableData1.tableData1, loading: false });
    }
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => props.setReload(!props.reload)} />
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return props.permissions.is_Export ? (
      <React.Fragment>
        <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />
      </React.Fragment>
    ) : (
      ""
    );
  };

  const header = (
    <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
      <h5 className="m-0">All Requirements</h5>
      <span className="block mt-2 md:mt-0 p-input-icon-left">
        <div style={{ display: "flex" }}>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: null };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "DodgerBlue", color: "white" }}
          >
            All
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Implementing_Partner" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "8rem", borderRadius: ".2rem", background: "orange", color: "white" }}
          >
            Imp. Partner
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "UnAllocated" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "skyblue", color: "white" }}
          >
            UnAlloc
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Served" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "green", color: "white" }}
          >
            Served
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Unserved" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "yellow", color: "black" }}
          >
            UnServed
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Rejected" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "red", color: "white" }}
          >
            Rejected
          </div>
          <div
            onClick={() =>
              setReqFilter((f) => {
                return { ...f, served_status: "Updated" };
              })
            }
            style={{ cursor: "pointer", marginRight: "2px", display: "flex", alignItems: "center", justifyContent: "center", height: "2.5rem", width: "5rem", borderRadius: ".2rem", background: "orange", color: "white" }}
          >
            Updated
          </div>

          {/* <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" /> */}
        </div>
      </span>
    </div>
  );

  // const header1 = (
  //     <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
  //         <h5 className="m-0">All Requirements</h5>
  //         <span className="block mt-2 md:mt-0 p-input-icon-left">
  //             <div style={{ display: 'flex' }}>
  //                 <div onClick={() => setduplicatereqFilter((f) => { return { ...f, served_status: null } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'DodgerBlue', color: 'white' }}>All</div>
  //                 <div onClick={() => setduplicatereqFilter((f) => { return { ...f, served_status: "UnAllocated" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'skyblue', color: 'white' }}>UnAlloc</div>
  //                 <div onClick={() => setduplicatereqFilter((f) => { return { ...f, served_status: "Served" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'green', color: 'white' }}>Served</div>
  //                 <div onClick={() => setduplicatereqFilter((f) => { return { ...f, served_status: "Unserved" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'yellow', color: 'black' }}>UnServed</div>
  //                 <div onClick={() => setduplicatereqFilter((f) => { return { ...f, served_status: "Rejected" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'red', color: 'white' }}>Rejected</div>
  //                 <div onClick={() => setduplicatereqFilter((f) => { return { ...f, served_status: "Updated" } })} style={{ cursor: 'pointer', marginRight: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '2.5rem', width: '5rem', borderRadius: '.2rem', background: 'orange', color: 'white' }}>Updated</div>
  //                 {/* <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" /> */}
  //             </div>
  //         </span>
  //     </div>
  // );

  // (_roles.includes(20) || _roles.includes(1) || _roles.includes(26))  && rowData.is_Duplicate === true

  const isDuplicate = (rowData: IAllRequirements) => {
    const duplicateCount = (_roles.includes(20) || _roles.includes(1) || _roles.includes(26)) && rowData.is_Duplicate === true ? rowData.all_Company_Duplicate_Count : rowData.duplicate_Count;
    return (
      <div>
        <div className=" flex flex-wrap">
          <span>{rowData.req_ID}</span>
          <button
            type="button"
            className="p-link "
            onClick={() => {
              duplicateCount == null ? setOpenDuplicateTable({ open: false, loading: false }) : setOpenDuplicateTable({ open: true, req_ID: rowData?.req_ID, loading: true });
            }}
          >
            <span className="border-circle w-1rem h-1rem flex align-items-center justify-content-center text-white" style={duplicateCount == null ? { backgroundColor: "" } : { backgroundColor: "red" }}>
              {duplicateCount}
            </span>
          </button>
        </div>
      </div>
    );
  };

  const req_Job_Title = (rowData: IAllRequirements) => {
    let isOpen = true;
    if (
      !(
        _roles.includes(1) ||
        _roles.includes(26) ||
        _roles.includes(5) ||
        _roles.includes(11) ||
        _roles.includes(20) ||
        loginObj.id === rowData.req_PostedBySalesManager ||
        (loginObj.is_Team_Lead === true && rowData.team_Manager == loginObj.id) ||
        (loginObj.is_Team_Lead === true && rowData.resource_Manager == loginObj.id)
      )
    ) {
      isOpen = false;
    }
    if (rowData.rejected_Status === "Yes") {
      return (
        <span
          onClick={() => {
            isOpen == false ? props.toast.current.show({ severity: "error", detail: "You can view only your and your's team JD.!", life: 3000 }) : setPublish({ singleData: rowData, open: isOpen });
            setRRR({ open: isOpen, rrreason: rowData.rejected_Comment, req_ID: rowData.req_ID });
          }}
          className="cursor-pointer underline"
        >
          <Tag severity="danger" value={rowData.req_Job_Title} />
        </span>
      );
    } else if (rowData.req_EditedBy) {
      return (
        <span onClick={() => (isOpen == false ? props.toast.current.show({ severity: "error", detail: "You can view only your and your's team JD.!", life: 3000 }) : setPublish({ singleData: rowData, open: isOpen }))} className="cursor-pointer underline">
          <Tag severity="warning" value={rowData.req_Job_Title} />
        </span>
      );
    } else {
      return (
        <span onClick={() => (isOpen == false ? props.toast.current.show({ severity: "error", detail: "You can view only your and your's team JD.!", life: 3000 }) : setPublish({ singleData: rowData, open: isOpen }))} className="cursor-pointer text-cyan-700 underline">
          {rowData.req_Job_Title}
        </span>
      );
    }
  };
  const pDate = (rowData: IAllRequirements) => {
    let date;
    if (rowData.pDate) date = format(new Date(rowData.pDate), "dd/MM/yyyy").toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  const pTime = (rowData: IAllRequirements) => {
    let date;
    if (rowData?.pDate) date = format(new Date(rowData?.pDate), "hh:mm a").toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  const [subTable, setSubTable] = useState({ req_id: 0, job_Title: "", open: false } as { req_id: number; job_Title?: string; open: boolean });
  const hideSubTable = () => {
    setSubTable({ req_id: 0, job_Title: "", open: false });
  };

  const submission_id = (rowData: IAllRequirements) => {
    const arOfCons = rowData.submission_id?.split(",");
    const arOfConsId: number[] = [];
    const arOfSubm = rowData.submission_status?.split(",");
    const subm: { [key: string]: number } = {};
    const key: string[] = [];
    arOfCons?.forEach((c) => {
      arOfConsId.push(parseInt(c.split("-")[0]));
      key.push(c.split("-")[0].trim());
    });
    arOfSubm?.forEach((s) => {
      const temp = s.split("-");
      subm[temp[0].trim()] = parseInt(temp[1]);
    });
    let is_Pending = 0;
    if (arOfCons) {
      for (let index = 0; index < arOfCons.length; index++) {
        if (subm[key[index]] === undefined) {
          is_Pending++;
        }
      }
    }

    const countOfSubmissions = rowData.submission_id?.split(", ").length;
    const color = countOfSubmissions === rowData.noofSUBRej ? "yellow" : countOfSubmissions ? "green" : rowData.recruiter ? "yellow" : "skyblue";

    return rowData.is_Update_Status === 1 ? (
      props.permissions.is_Create ? (
        <div style={{ background: color, minWidth: "70px", minHeight: "30px", display: "flex", alignItems: "center", justifyContent: "center", padding: "3px" }}>
          <span
            className={countOfSubmissions === rowData.noofSUBRej ? "cursor-pointer underline " : "cursor-pointer text-white underline"}
            onClick={() => {
              if (rowData.req_ID) setSubTable({ req_id: rowData.req_ID, job_Title: rowData.req_Job_Title, open: true });
            }}
          >
            {rowData.submission_id}
          </span>
        </div>
      ) : (
        <div style={{ background: color, minWidth: "70px", minHeight: "30px", display: "flex", alignItems: "center", justifyContent: "center", padding: "3px" }}>
          <span className={countOfSubmissions === rowData.noofSUBRej ? "text-black-alpha-50" : "text-white"}>{rowData.submission_id}</span>
        </div>
      )
    ) : (
      <div style={{ background: color, minWidth: "70px", minHeight: "30px", display: "flex", alignItems: "center", justifyContent: "center", padding: "3px" }}>
        <span className={countOfSubmissions === rowData.noofSUBRej ? "text-black-alpha-50" : "text-white"}>{rowData.submission_id}</span>
      </div>
    );
  };

  const noofPO = (rowData: IAllRequirements) => {
    return (
      <span
        onClick={() => {
          if (rowData.vendor_Company_ID) setPODetails({ vendor_Company_ID: rowData.vendor_Company_ID, open: true });
        }}
        className="cursor-pointer text-cyan-700 underline"
      >
        {rowData.noofPO}
      </span>
    );
  };

  const loadBlacklistDetail = async (req_ID?: number) => {
    const response = await Fetch("Requirement_MAST/blacklistSubmission", "GET", null, `req_id=${req_ID}`, props.toast);

    if (response) {
      const data = await response.json();
      setBlacklisttableData({ blacklisttableData: data, loading: false });
    } else {
      setBlacklisttableData({ blacklisttableData: [], loading: false });
    }
  };


  const blacklistDetail = (rowData: IAllRequirements) => {
    const rawValue = rowData.blacklisted_SV_Sub;
    if (!rawValue) return null;

    const blacklistedNames = rawValue.split(",").map((item) => {
      const parts = item.trim().split("-");
      return parts[1]?.trim() || "";
    });

    const handleClick = () => {
      loadBlacklistDetail(rowData.req_ID);
      setOpenBlacklistSubmission(true);
    };

    return (
      <div
        style={{
          color: "#c00",
          cursor: "pointer",
          fontWeight: "500",
          lineHeight: "1.5",
          textDecoration: "underline",
        }}
        onClick={handleClick}
      >
        <ul style={{ margin: 0, paddingLeft: "20px" }}>
          {blacklistedNames.map((name, idx) => (
            <li key={idx}>{name}</li>
          ))}
        </ul>
      </div>
    );
  };

  const blacklistReason = (rowData: any) => {
    return (
      <span
        className="p-link"
        style={{ fontWeight: 600, color: "#14A4E0" }}
        onClick={() => {
          setBlacklistModal({
            open: true,
            reason: rowData.blacklisted_SV_Sub_Reason,
          });
        }}
      >
        View
        {/* <i className="pi pi-eye" style={{ marginLeft: 6 }} /> */}
      </span>
    );
  };


  // const rowClass = (data: any) => {

  //     return {
  //         'bg-gray-400 ': data.is_Duplicate === true,
  //         'bg-orange-100 font-semibold': data.reqType_ID === 1,

  //     };
  // }
  //   console.log(blacklistReasonView,"121")
  const rowClass = (data: any) => {
    if (data.client_Type === Client_Type.Implementing_Partner) {
      return "bg-pink-100 font-semibold";
    } else if (data.reqType_ID === 1) {
      return "bg-orange-100 font-semibold";
    } else if (data.category) {
      return "bg-indigo-200 font-semibold";
    } else if (data.is_Duplicate === true) {
      return "bg-gray-400 ";
    } else {
      return "";
    }
  };

  const onHideDuplicate = () => {
    setOpenDuplicateTable({ open: false, loading: true });
  };

  const loadDuplicateCount = async () => {
    let response = await Fetch("Requirement_MAST/duplicateCount", "GET", null, null, props.toast);
    if (response) {
      const data: number = parseInt(await response.text(), 0);
      setDuplicateReqCount(data);
    }
  };

  const onHideHistoryTable = () => {
    setHistoryTable({ req_ID: 0, open: false });
  };

  const loadHoldUnholdHistory = async (req_ID?: number) => {
    setHistorytableData({ historytableData: historytableData.historytableData, loading: true });
    const response = await Fetch("Requirement_MAST/holdUnholdHistory", "GET", null, `req_id=${req_ID}`, props.toast);
    if (response) {
      const data: Array<any> = await response.json();
      setHistorytableData({ historytableData: data, loading: false });
    } else {
      setHistorytableData({ historytableData: historytableData.historytableData, loading: false });
    }
  };
  const pDate1 = (rowData: any) => {
    let date;
    if (rowData.hold_Unhold_Datee) date = format(new Date(rowData.hold_Unhold_Datee), "dd/MM/yyyy").toUpperCase();
    else date = "";
    return <>{date}</>;
  };

  const pTime1 = (rowData: any) => {
    let date;
    if (rowData?.hold_Unhold_Datee) date = format(new Date(rowData?.hold_Unhold_Datee), "hh:mm a").toUpperCase();
    else date = "";
    return <>{date}</>;
  };
  const rejectFunc = () => {
    props.toast.current.show({ severity: "error", detail: "You have Canceled", life: 3000 });
  };
  const RemoveRequirement = async (rowData: IAllRequirements) => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("Requirement_MAST", "DELETE", null, `Req_ID=${rowData.req_ID}`, props.toast);
    if (response) {
      props.toast.current.show({ severity: "success", detail: " Requirement Removed", life: 3000 });
      loadTableData();
      setLoading(false);
    } else {
      setTableData({ tableData: tableData.tableData, loading: false });
    }
  };
  const confirmDelete = (rowData: any) => {
    confirmDialog({
      message: `Are you sure you want to delete this requirements `,
      header: "Confirm Delete",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => RemoveRequirement(rowData),
      reject: () => rejectFunc(),
    });
  };
  const actionBodyTemplate = (rowData: IAllRequirements | any) => {
    return (
      <div className="flex gap-3">
        <Button
          icon="pi pi-times"
          tooltip="Remove 4th Allocation"
          tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}
          className="p-button-sm p-button-danger my-1"
          type="button"
          onClick={() => {
            setRemoveAllocation({ open: true, req_ID: rowData.req_ID, noSub_Allocated: rowData.noSub_Allocated });
          }}
        />
        <Button
          className="pi pi-trash  bg-white border-none"
          style={{ fontSize: "2 rem", backgroundColor: "white", borderColor: "red", color: "red" }}
          onClick={() => { confirmDelete(rowData); }} />
      </div>
    );
  };

  const toggleVal = async (req_ID: number) => {
    const response = await Fetch("Requirement_MAST/togglesuballocation", "PUT", null, `Req_ID=${req_ID}`, props.toast);
    if (response) {
      let message: string = "Status Changed";
      props.toast.current.show({ severity: "success", detail: message, life: 3000 });
      loadTableData();
      setRemoveAllocation({ req_ID: removeAllocation.req_ID, open: false, noSub_Allocated: removeAllocation.noSub_Allocated });
    }
  };

  const handleTagClick = () => {
    if (removeAllocation.noSub_Allocated == true) {
      toggleVal(removeAllocation.req_ID);
    } else {
      props.toast.current.show({ severity: "error", detail: "4th allocation not done yet", life: 3000 });
    }
  };
  useEffect(() => {
    loadTableData1(openDuplicateTable.req_ID);
  }, [openDuplicateTable, props.reload]);

  const DataFormat = loginObj.date_Format;

  return (
    <>
      <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
      <Accordion>
        <AccordionTab header="Filter">
          <Filter reqFilter={reqFilter} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={4} />
        </AccordionTab>
      </Accordion>
      <DataTable
        style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
        ref={dt}
        size="small"
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
        value={tableData.tableData}
        emptyMessage="No Requirements found."
        header={header}
        loading={tableData.loading}
        rowClassName={rowClass}
      >
        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
        <Column field="req_ID" header="Req.ID" sortable body={isDuplicate} style={{ maxWidth: "16rem", overflow: "hidden" }} />
        <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
        <Column field="req_Duration" header="Duration" />
        <Column field="location" header="Location" />
        <Column field="req_CategoryName" header="Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
        <Column field="req_Sub_CategoryName" header="Sub Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
        <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
        <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
        {/* <Column field="client_Type" sortable header="Client Type" /> */}

        {/* <Column field="pDate" header="Posted On" body={pDate} /> */}
        <Column field="pDate" style={{ minWidth: "100px" }} header="Posted On" body={(rowData: any) => safeFormatDate(rowData.pDate, "dd/MM/yyyy", DataFormat)} />
        <Column field="pDate" header="Posted Time" body={pTime} />
        <Column field="user_Name" sortable header="Sales Manager"
          body={(r: IAllRequirements) => <User req={{
            reqId: r.req_ID ?? '',
            jobTitle: r.req_Job_Title ?? '',
            postedDate: r.pDate ?? '',
            userId: r.req_PostedBySalesManager ?? 0,
            userName: r.user_Name ?? '',
          }}
          />} />
        <Column field="salesCompany" header="Sales Comp(Branch)" />
        <Column field="no_Auto_Allocation" header="Auto Allocation" body={(rowData) => <span style={{ color: rowData.no_Auto_Allocation ? "red" : "green" }}>{rowData.no_Auto_Allocation ? "No" : "yes"}</span>} />
        <Column
          field="recruiter"
          header="Recruiter"
          body={(rowData: any) => {
            const recNames: string[] = (rowData?.recruiter?.trim() || "").split(",").map((elee: string) => `${elee.trim().split("-")[0]}-${elee.trim().split("-")[1]}`);
            return rowData?.recruiter !== null && rowData?.recruiter !== undefined ? (
              <div>
                {recNames.map((elN: string) => (
                  <span>{elN},</span>
                ))}
              </div>
            ) : (
              <></>
            );
          }}
        />
        <Column field="submission_id" header="Submittals" body={submission_id} />
        {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(4)) && <Column field="blacklisted_SV_Sub" header="Blacklisted SV_Submission" body={blacklistDetail} />}
        <Column field="req_EndClient" sortable header="End Client" />
        <Column field="client_Communication" sortable header="Client Communication" />
        <Column field="special_Constraint" header="Special Constraint" />

        {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && !_roles.includes(40) && <Column field="client" sortable header="Client" />}
        {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && !_roles.includes(40) && <Column field="contact_Person_Name" header="Contact Person" />}
        {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && <Column field="noofPO" sortable header="#PO" body={noofPO} />}
        <Column field="hold" header="Status" body={(rowData: IAllRequirements) => rowData.hold ? "Hold" : "Unhold"} />
        <Column
          field=""
          header="Hold/Unhold History"
          body={(rowData) => (
            <i
              className="cursor-pointer text-primary pi pi-history"
              onClick={() => {
                loadHoldUnholdHistory(rowData.req_ID);
                setHistoryTable({ req_ID: rowData.req_ID, open: true });
              }}
            ></i>
          )}
        />
        {_roles.includes(1) && <Column body={actionBodyTemplate} header="Action" />}
      </DataTable>
      <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
      {/* <Filter hideDialog={hideFilterDialog} open={filter} toast={props.toast} setReqFilter={(reqFilter: IReqFilter) => setReqFilter(reqFilter)} ft={4} /> */}
      <SubmissionsTable req_id={subTable.req_id} job_Title={subTable.job_Title} open={subTable.open} hideDialog={hideSubTable} toast={props.toast} reload={props.reload} setReload={props.setReload} />
      <POReport open={poDetails.open} vendor_Company_ID={poDetails.vendor_Company_ID} hideDialog={hidePODetailsDialog} toast={props.toast} />
      <Dialog visible={rrr.open} style={{ width: "80vw" }} header={`Requirement - (${rrr.req_ID}) Rejection Reason`} className="p-fluid" onHide={hideRRRDialog}>
        <JVSunEditor value={rrr.rrreason} />
      </Dialog>

      {/* Duplicate Table  are started */}
      <Dialog visible={openDuplicateTable.open} style={{ width: "80vw" }} header="Duplicate Requirements" modal className="p-fluid" onHide={onHideDuplicate}>
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          ref={dt}
          size="small"
          stripedRows
          showGridlines
          responsiveLayout="scroll"
          exportFilename={format(new Date(), "dd-MM-yyyy hh_mm_ss a").toUpperCase()}
          value={tableData1.tableData1}
          emptyMessage="No Requirements found."
          loading={tableData1.loading}
          rowClassName={rowClass}
        >
          <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
          <Column field="req_ID" header="Req.ID" sortable />
          <Column field="req_Job_Title" sortable header="Job Title" />
          <Column field="req_Duration" header="Duration" />
          <Column field="location" header="Location" />
          <Column field="req_CategoryName" header="Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
          <Column field="req_Sub_CategoryName" header="Sub Category" style={{ maxWidth: "8rem", overflow: "hidden" }} sortable />
          <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
          <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
          {/* <Column field="pDate" header="Posted On" body={pDate} /> */}
          <Column field="pDate" style={{ minWidth: "100px" }} header="Posted On" body={(rowData: any) => safeFormatDate(rowData.pDate, "dd/MM/yyyy", DataFormat)} />
          <Column field="user_Name" sortable header="Sales Manager" />
          <Column field="salesCompany" header="Sales Comp(Branch)" />
          <Column
            field="recruiter"
            header="Recruiter"
            body={(rowData: any) => {
              const recNames: string[] = (rowData?.recruiter?.trim() || "").split(",").map((elee: string) => `${elee.trim().split("-")[0]}-${elee.trim().split("-")[1]}`);
              return rowData?.recruiter !== null && rowData?.recruiter !== undefined ? (
                <div>
                  {recNames.map((elN: string) => (
                    <span>{elN},</span>
                  ))}
                </div>
              ) : (
                <></>
              );
            }}
          />
          <Column field="submission_id" header="Submittals" body={submission_id} />
          <Column field="req_EndClient" sortable header="End Client" />
          <Column field="client_Communication" sortable header="Client Communication" />
          {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && !_roles.includes(40) && <Column field="client" sortable header="Client" />}
          {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && !_roles.includes(40) && <Column field="contact_Person_Name" header="Contact Person" />}
          {(_roles.includes(1) || _roles.includes(26) || _roles.includes(5) || _roles.includes(11) || _roles.includes(20)) && <Column field="noofPO" sortable header="#PO" body={noofPO} />}
          <Column field="hold" header="Status" body={(rowData: IAllRequirements) => rowData.hold ? "Hold" : "Unhold"} />
        </DataTable>
      </Dialog>

      <Dialog visible={historyTable.open} style={{ width: "80vw" }} header="Hold/UnHold History" modal className="p-fluid" onHide={onHideHistoryTable}>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }} ref={dt} size="small" stripedRows scrollable scrollHeight="65vh" emptyMessage="No Branches found." loading={historytableData.loading} value={historytableData.historytableData}>
          <Column field="updated_By_Name" header="Updated By" />
          {/* <Column field="hold_Unhold_Datee" header="Date" body={pDate1} /> */}
          <Column field="hold_Unhold_Datee" header="Date" body={(rowData: any) => safeFormatDate(rowData.hold_Unhold_Datee, "dd/MM/yyyy", DataFormat)} />
          <Column field="hold_Unhold_Datee" header="Time" body={pTime1} />
          <Column field="holdUnhold_Typee" header="Action" body={(rowData: any) => rowData.holdUnhold_Typee === true ? "Hold" : "Unhold"} />
        </DataTable>
      </Dialog>

      {/* ------------------Removing fourth allocation functionality start----------------------------------------------------- */}
      <Dialog visible={removeAllocation.open} header={`Requirement - (${removeAllocation.req_ID})`} style={{ width: "50vw" }} modal className="p-fluid" onHide={hideQueryDialog}>
        <div style={{ marginTop: "20px", textAlign: "center" }}>
          <p className="text-2xl underline" style={{ color: "blue", fontWeight: "bolder" }}>
            Do you really want to remove 4th allocation status
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "10px", marginTop: "5px" }}>
            <Button icon="pi pi-check" className="p-button-sm my-1 bg-green-500" label="Yes" type="button" onClick={handleTagClick}></Button>
            <Button icon="pi pi-times" className="p-button-sm p-button-danger my-1" label="No" type="button" onClick={hideQueryDialog}></Button>
          </div>
        </div>
      </Dialog>

      <Dialog visible={openBlacklistSubmission} header="Blacklisted Submissions" onHide={() => setOpenBlacklistSubmission(false)} modal style={{ width: "60vw" }}>
        <DataTable
          style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", marginTop: "5px" }}
          ref={dt}
          size="small"
          stripedRows
          scrollable
          scrollHeight="65vh"
          emptyMessage="No Blacklisted SV_Submission found."
          loading={blacklisttableData.loading}
          value={blacklisttableData.blacklisttableData}
        >
          <Column field="vendor_Company_Name" header="SubVendor Company" />
          <Column field="consultantName" header="Consultant" />
          <Column field="recruiter_Name" header="Recruiter" />
          <Column field="submitalDate" header="Submission Date" body={(rowData: any) => safeFormatDate(rowData.submitalDate, "dd/MM/yyyy", DataFormat)} />
          <Column header="Submission Reason" body={blacklistReason} />
        </DataTable>
      </Dialog>
      <Dialog visible={blacklistModal.open} onHide={() => setBlacklistModal({ open: false, reason: "" })} modal header="Submission Reason" style={{ width: "30vw" }}>
        <p>{blacklistModal.reason}</p>
      </Dialog>

      <ConfirmDialog />
    </>
  );
};
